/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  PRICING DATA
  ============================================================

  Tämä on Premium-demon esimerkkihinnasto.
  Varsinaisessa asiakastoteutuksessa hinnat ja paketit tulevat
  WordPress-hallinnasta.
*/

const pricingData = {
  hero: {
    image: "/media/pricing/pricing-hero.webp",
    imagePosition: "50% 50%",

    eyebrow: {
      fi: "Hinnasto",
      en: "Pricing",
    },

    title: {
      fi: "Kuvaus, joka tuntuu omalta.",
      en: "Photography that feels like you.",
    },

    description: {
      fi: "Hyvät kuvat eivät synny kellosta katsomalla. Valitse sinulle sopiva kokonaisuus tai kerro ajatuksestasi – rakennetaan kuvaus, joka tuntuu omalta alusta loppuun.",
      en: "Meaningful photographs are not created by watching the clock. Choose the collection that feels right or tell me what you have in mind – we can shape the session around you.",
    },
  },

  notice: {
    fi: "Hinnat alkaen · kuvaus ja paketin sisältö voidaan räätälöidä tarpeen mukaan.",
    en: "Prices from · sessions and package contents can be tailored to your needs.",
  },

  groups: [
    {
      id: "weddings",
      number: "01",
      title: { fi: "Hääkuvaus", en: "Weddings" },
      description: {
        fi: "Pienestä vihkimisestä koko päivän dokumentaariseen tarinaan.",
        en: "From an intimate ceremony to a full documentary wedding story.",
      },
      packages: [
        {
          name: { fi: "Vihkiminen + potretit", en: "Ceremony + portraits" },
          meta: { fi: "n. 2 tuntia", en: "approx. 2 hours" },
          price: "795 €",
          features: {
            fi: ["Suunnittelupalaveri", "Vihkiminen ja hääpotretit", "Valikoidut ja viimeistellyt kuvat", "Yksityinen verkkogalleria"],
            en: ["Planning meeting", "Ceremony and portraits", "Curated and edited photographs", "Private online gallery"],
          },
        },
        {
          name: { fi: "Dokumentaarinen 8 h", en: "Documentary 8 h" },
          meta: { fi: "vihkimisestä juhlaan", en: "from ceremony to celebration" },
          price: "1 890 €",
          featured: true,
          features: {
            fi: ["8 tuntia kuvausta", "Potretit, vihkiminen ja juhla", "Laaja viimeistelty kuvagalleria", "Suunnittelu ennen hääpäivää"],
            en: ["8 hours of coverage", "Portraits, ceremony and reception", "Extensive edited gallery", "Pre-wedding planning"],
          },
        },
        {
          name: { fi: "Dokumentaarinen 10 h", en: "Documentary 10 h" },
          meta: { fi: "valmisteluista iltaan", en: "from preparations into the evening" },
          price: "2 190 €",
          features: {
            fi: ["10 tuntia kuvausta", "Päivän tärkeät vaiheet", "Laaja viimeistelty kuvagalleria", "Suunnittelu ennen hääpäivää"],
            en: ["10 hours of coverage", "The key chapters of your day", "Extensive edited gallery", "Pre-wedding planning"],
          },
        },
        {
          name: { fi: "Koko päivä 12 h", en: "Full day 12 h" },
          meta: { fi: "aamusta iltaan", en: "from morning into the evening" },
          price: "2 490 €",
          features: {
            fi: ["12 tuntia kuvausta", "Koko päivän dokumentaarinen tarina", "Laaja viimeistelty kuvagalleria", "Suunnittelu ennen hääpäivää"],
            en: ["12 hours of coverage", "A full documentary wedding story", "Extensive edited gallery", "Pre-wedding planning"],
          },
        },
      ],
    },

    {
      id: "couples",
      number: "02",
      title: { fi: "Parikuvaus", en: "Couples" },
      description: {
        fi: "Rento kuvaus kahdelle luonnonvalossa, kaupungissa tai teille tärkeässä miljöössä.",
        en: "A relaxed session for two in natural light, the city or a place that means something to you.",
      },
      packages: [
        {
          name: { fi: "Hetki", en: "Moment" },
          meta: { fi: "n. 60 minuuttia", en: "approx. 60 minutes" },
          price: "290 €",
          features: {
            fi: ["Suunnittelu ennen kuvausta", "Kuvaus miljöössä", "Viimeistellyt digikuvat", "Yksityinen verkkogalleria"],
            en: ["Pre-session planning", "On-location session", "Edited digital photographs", "Private online gallery"],
          },
        },
        {
          name: { fi: "Tarina", en: "Story" },
          meta: { fi: "n. 90 minuuttia", en: "approx. 90 minutes" },
          price: "390 €",
          featured: true,
          features: {
            fi: ["Väljempi kuvausaika", "Mahdollisuus kahteen miljööseen", "Laajempi kuvavalikoima", "Yksityinen verkkogalleria"],
            en: ["More relaxed session time", "Possibility for two locations", "Larger image selection", "Private online gallery"],
          },
        },
      ],
    },

    {
      id: "portraits",
      number: "03",
      title: { fi: "Henkilökuvaus", en: "Portraits" },
      description: {
        fi: "Luonnolliset henkilökuvat omaan käyttöön, portfolioon tai ammatilliseen näkyvyyteen.",
        en: "Natural portraits for personal use, a portfolio or professional visibility.",
      },
      packages: [
        {
          name: { fi: "Portrait", en: "Portrait" },
          meta: { fi: "n. 45 minuuttia", en: "approx. 45 minutes" },
          price: "240 €",
          features: {
            fi: ["Kuvaus yhdessä miljöössä", "Ohjaus kuvauksen aikana", "Viimeistellyt digikuvat", "Yksityinen verkkogalleria"],
            en: ["One location", "Guidance throughout the session", "Edited digital photographs", "Private online gallery"],
          },
        },
        {
          name: { fi: "Editorial", en: "Editorial" },
          meta: { fi: "n. 90 minuuttia", en: "approx. 90 minutes" },
          price: "390 €",
          featured: true,
          features: {
            fi: ["Suunniteltu kuvallinen kokonaisuus", "Asu- tai miljöövaihdot", "Laajempi kuvavalikoima", "Yksityinen verkkogalleria"],
            en: ["A planned visual concept", "Outfit or location changes", "Larger image selection", "Private online gallery"],
          },
        },
      ],
    },
  ],

  extras: {
    eyebrow: { fi: "Lisäpalvelut", en: "Add-ons" },
    title: { fi: "Kokonaisuus voidaan rakentaa tarpeen mukaan.", en: "Build the experience around what you need." },
    items: [
      { label: { fi: "Lisätunti hääpäivään", en: "Additional wedding hour" }, price: "190 €" },
      { label: { fi: "Pikatoimitus", en: "Express delivery" }, price: "150 €" },
      { label: { fi: "Fine art -albumit", en: "Fine art albums" }, price: { fi: "alk. 290 €", en: "from €290" } },
    ],
  },
};

export default pricingData;
